/* eslint-disable complexity */

import {
  BookWidgetFields,
  TripTypeOptions
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { Segment } from '../../models/postData-search-local-storage.interface';
import { formatDateString } from './postData-utils.adaptor';

export const getSegmentForTripType = (
  bookWidgetFields?: BookWidgetFields
): Segment[] => {
  if (
    !bookWidgetFields?.tripTypesField?.selectedTripType ||
    !bookWidgetFields?.airportsField?.airports?.length ||
    !bookWidgetFields?.datesField?.dates?.length
  ) {
    return [];
  }

  const tripType = bookWidgetFields.tripTypesField.selectedTripType;
  const airports = bookWidgetFields.airportsField.airports;
  const dates = bookWidgetFields.datesField.dates;

  switch (tripType) {
    case TripTypeOptions.ROUND_TRIP:
      return [
        {
          origin: airports[0]?.fromAirportcode,
          destination: airports[0]?.toAirportcode,
          originCountryCode: airports[0]?.fromCountryCd || '',
          destinationCountryCode: airports[0]?.toCountryCd || '',
          departureDate: formatDateString(dates[0].start),
          returnDate: formatDateString(dates[0].end),
          originCity: airports[0]?.fromCity || '',
          destinationCity: airports[0]?.toCity || ''
        }
      ];

    case TripTypeOptions.ONE_WAY:
      return [
        {
          origin: airports[0]?.fromAirportcode,
          destination: airports[0]?.toAirportcode,
          originCountryCode: airports[0]?.fromCountryCd || '',
          destinationCountryCode: airports[0]?.toCountryCd || '',
          departureDate: formatDateString(dates[0].start),
          originCity: airports[0]?.fromCity || '',
          destinationCity: airports[0]?.toCity || ''
        }
      ];

    case TripTypeOptions.MULTI_CITY:
      return airports.map((airport, index) => ({
        origin: airport.fromAirportcode || '',
        destination: airport.toAirportcode || '',
        originCountryCode: airport?.fromCountryCd || '',
        destinationCountryCode: airport?.toCountryCd || '',
        departureDate: formatDateString(dates[index].start) || '',
        connectionAirportCode: airport.connectionAirport || null,
        originCity: airport?.fromCity || '',
        destinationCity: airport?.toCity || ''
      }));

    default:
      return [];
  }
};
